import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { Button } from '../ui/button';
import { ArrowLeft, Search, Home, Key, Shield } from 'lucide-react';

const HowItWorks = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="pt-16">
        {/* Header */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex items-center space-x-4">
              <Button 
                variant="ghost" 
                onClick={() => window.history.back()}
                className="text-red-600 hover:text-red-700"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
              <h1 className="text-3xl font-bold gradient-text">How RentalX Works</h1>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold gradient-text mb-6">
              Simple Steps to Find Your Home
            </h2>
            <p className="text-xl text-gray-600">
              Our streamlined process makes it easy to find, book, and move into your ideal student accommodation.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HowItWorks;